import { render, staticRenderFns } from "./SelectedClass.vue?vue&type=template&id=97a1a7ba&scoped=true&"
import script from "./SelectedClass.vue?vue&type=script&lang=js&"
export * from "./SelectedClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a1a7ba",
  null
  
)

export default component.exports